import Component from './src/Component'
export default Component
